import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface OrderStoreModalProps {
  isOpen: boolean;
  toggle: () => void;
  selectedStore: string;
  setSelectedStore: (status: string) => void;
  ordersListStore: { id: string; name: string }[];
  handleStoreUpdate: () => void;
}

const OrderStoreUpdate: React.FC<OrderStoreModalProps> = ({
  isOpen,
  toggle,
  selectedStore,
  setSelectedStore,
  ordersListStore,
  handleStoreUpdate,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Store</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="form-label" htmlFor="status-select">
            Select Store
          </label>
          <select
            className="form-control"
            id="status-select"
            name="orderStatus"
            onChange={(e) => setSelectedStore(e.target.value)}
            value={selectedStore}
          >
            <option value="">Select Store</option>
            {ordersListStore?.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Discard
        </Button>
        <Button color="primary" onClick={handleStoreUpdate}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrderStoreUpdate;
